module.exports = __webpack_public_path__ + "media/images/social-icons/instagram-04bf8424c3ca5a6b630c45a68de5668e.svg";